<template>
  <base-layout ref="baselayout">
  <div class="row" v-if="!isActive && !TimesheetApprove">
    <div class="col-md-12" style="margin-top:-10px">
      <div class="col-md-9">
        <ul class=" clearfix list-unstyled list-inline">
          <template>
              <li>
                <span class="circle"></span>
                <span class="span_styles">PENDING LEAVE APPROVAL</span>
              </li>
              <li>
                <span class="circle6"></span>
                <span class="span_styles">REQUESTED FOR EDIT</span>
              </li>
              <li>
                <span class="circle1"></span>
                <span class="span_styles">TIME OFF</span>
              </li>
              <li>
                <span class="circle2"></span>
                <span class="span_styles">APPROVED</span>
              </li>
              <li>
                <span class="circle3"></span>
                <span class="span_styles">PENDING</span>
              </li>
              <li>
                <span class="circle4"></span>
                <span class="span_styles">REJECTED</span>
              </li>
              <li>
                <span class="circle7"></span>
                <span class="span_styles">INVOICE GENERATED</span>
              </li>
              <!-- <li>
                <span class="circle5"></span>
                <span class="span_styles">IN-PROGRESS</span>
              </li> -->
          </template>
        </ul>
      </div>
      <div class="col-md-3" style="margin-right: 0px;padding-right:0px">
        <a style="text-decoration:none;float:right" @click="toggle">Hide Color Codes</a> 
      </div>
    </div>
  </div> 
    <div class="timesheet_layout" style="min-height: 300px;">
      <div class="row" style="margin-right: 0px;">
        <div class="col-md-12" style="margin-bottom: -15px;" v-if="!TimesheetApprove">
          <ul class="clearfix list-unstyled list-inline" >
            <div v-show="!OpenTimesheetManualRemainder && !showShareTimesheetPopup">
            <ul
              v-show="legend"
              class="clearfix list-unstyled list-inline pull-left"
              style="margin-left: 10px"
            >
              <li v-if="IsSupervisor">
                <h5 class="h3_styles">
                  <ob-select2 :options="timeSheetOptions" v-model.trim="TimeSheets"></ob-select2>
                </h5>
              </li>
              <li v-else>
                <h3 class="h3_styles">Timesheets & Expenses</h3>
              </li>
              <li>
                <h3 class="h3_styles" style="width: 100px;">
                  <ob-date-time-picker
                    id="createDate"
                    placeholder="Select "
                    :options="options1"
                    :inputvalue="Year"
                    @updated="(v) => this.Year = v"
                    v-model.trim="Year"
                  ></ob-date-time-picker>
                </h3>
              </li>
              <li>
                <h5 class="h3_styles">
                  <ob-select2
                    :options="monthOptions"
                    v-model.trim="Month"
                    style="min-width: 100px;"
                  ></ob-select2>
                </h5>
              </li>
              <li class="arrow_icon" @click="onPreviousMonthClick()">
                <span>
                  <img class :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_previous.svg`" />
                </span>
              </li>
              <li class="arrow_icon" @click="onNextMonthClick()">
                <span>
                  <img class :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_next.svg`" />
                </span>
              </li>
              <li class="timesheet_filter">
                <img @click="showFilter = true" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_filter.svg`" alt="image" />
              </li>
              <ob-button
                class="clear-btn"
                type="link"
                :style="{'visibility':isFilterApplied ? 'visible':'hidden'}"
                @click="clearFilter"
              >Clear</ob-button>
            </ul>
            </div>
            <ul class="pull-right clearfix list-unstyled list-inline" style="margin:0px;">
              <template v-if="ManualRemainderEmpList.length == 0">
              <!-- <li class="legend-li">
                <span class="circle"></span>
                <span class="span_styles">PENDING LEAVE APPROVAL</span>
              </li>
              <li>
                <span class="circle5"></span>
                <span class="span_styles">EDIT REQUEST</span>
              </li>
              <li class="legend-li">
                <span class="circle1"></span>
                <span class="span_styles">TIME OFF</span>
              </li>
              <li class="legend-li">
                <span class="circle2"></span>
                <span class="span_styles">APPROVED</span>
              </li>
              <li class="legend-li">
                <span class="circle3"></span>
                <span class="span_styles">PENDING</span>
              </li>
              <li v-if="CalendarView == 'customViewYearly'">
                <span class="circle4"></span>
                <span class="span_styles">REJECTED</span>
              </li> -->
<a style="text-decoration:none;color:#000000;padding-right:5px"  v-show="isActive" @click="toggle">{{isActive ? 'Show Color Codes ' : 'Hide Color Codes'}}</a>
              </template>
              <template v-else>
                  <li style="cursor: pointer"  @click="onShareTimesheetClick()" v-if="ManualRemainderEmpList.length == 1"  class="legend-li">
                      <span>
                         <img  class="cross-img" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Icon_share1.svg`">
                      </span>
                      <span style="color: #254c86;font-size: 14px;font-weight: 600;">Share</span>
                  </li>
                  <li  style="cursor: not-allowed;"  v-if="ManualRemainderEmpList.length > 1" class="legend-li">
                      <span>
                         <img  class="cross-img" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Icon_share2.svg`">
                      </span>
                      <span style="color: #D6D6D6;font-size: 14px;font-weight: 600;">Share</span>
                  </li>

                  <li class="legend-li">
                    <div class="send_manual_remainder"  @click="OpenTimesheetManualRemainder = true">
                      <span>
                         <img  class="cross-img" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_timesheet_reminder.svg`">
                      </span>
                       <span style="padding-top:1px">Send Reminder</span>
                  </div>
                  </li>
              </template>
              <template>
  <ob-modal2 :show.sync="generatePopupSuccessContent" :backdrop="false" width="700px">
    <template slot="modal-body">
      <div>
        <img class="center" style="height:150px;display: block; margin-left: auto; margin-right: auto;" :src="`${CDNIMAGESBASEURL}/commonimages/oblaptop-downloadobk.svg`" /> <br/>
      <p style="text-align:center;font-size:16px;">We have started preparing your timesheet report, it will take few minutes.</p>
      <p style="text-align:center;font-size:16px">We will send you the report to <b>{{this.loggedInUserObj.email}}</b> once it is generated.</p>
      </div>
      </template>
      <template slot="modal-footer">
      <ob-button  v-if="generatePopupSuccessContent" type="secondary" @click="cancel()">Ok, Got it</ob-button>
    </template>
    </ob-modal2>
    </template>
              <ob-dropdown title="Reports" class="js-stop-propagate-class">
              <template >

                    <ob-dropdown-list-item style="width:200px;padding-right:0px" v-if="!IsReportGenerationInProgress"  
                      @click.native="exportToExcel()"><span>Export as Excel</span></ob-dropdown-list-item>
                    <span  v-else v-tooltip="'Timesheets report generation is in-progress so please wait till it is completed.'">
                      <ob-dropdown-list-item style="width:200px;padding-right:0px" :disabled="true" 
                        :class="{'disable-options': true}">Export as Excel</ob-dropdown-list-item> 
                    </span>               

                    <ob-dropdown-list-item  v-if="!IsReportGenerationInProgress"  style="width:200px"  :disabled="IsReportGenerationInProgress" 
                      type="secondary" @click.native="generateReport()"><span>Generate  Detailed Report</span></ob-dropdown-list-item>

                    <span v-else v-tooltip="'Timesheets report generation is in-progress so please wait till it is completed.'">
                      <ob-dropdown-list-item style="width:200px;padding-right:0px"  :disabled="true" 
                        :class="{'disable-options': true}">Generate  Detailed Report</ob-dropdown-list-item>   
                    </span>                

                    <ob-dropdown-list-item style="width:200px"  v-if="IsDCAAComplianceToggleOn" @click.native="addDcaaReport()">DCAA Report</ob-dropdown-list-item>
              </template>
          </ob-dropdown>
              <!-- <li class="legend-li">

                 <ob-button  :style="{'display':isSearchFilterAppiled ? 'block':'none'}" :disabled="IsReportGenerationInProgress"  @click="exportToExcel()">
                            <span v-if="IsReportGenerationInProgress" v-tooltip="'Timesheets report generation is in-progress so please wait till it is completed.'">Export as Excel</span>
                            <span v-else>Export as Excel</span>
                  </ob-button>
              </li>
              <li class="legend-li">
                 <ob-button :disabled="IsReportGenerationInProgress" type="secondary" @click="generateReport()">
                            <span v-if="IsReportGenerationInProgress" v-tooltip="'Timesheets report generation is in-progress so please wait till it is completed.'">Generate Report</span>
                            <span v-else>Generate Report</span>
                  </ob-button>
              </li> -->
              <li class="legend-li" v-if="!selectAddTimesheet"><ob-button type="secondary" @click="addTimesheets()" style="background-color:#143361;color:#ffffff">Add Timesheet</ob-button></li>
              <li class="legend-li" v-else><ob-button type="secondary" v-tooltip="'Add Timesheet'"> <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_addts-selected.svg`"> </ob-button></li>
               <li  class="legend-li">
                  <div style="padding: 6px;background: #1f2023;border-radius: 5px;">

                      <ob-popover :visibleArrow="false" trigger="click" :options="{placement: 'bottom'}" ref="popover">
                        <div class="popper">
                            <div class="view-options">
                              <p class="view-options-p" v-bind:class="{'view_option' : IsCalender }" @click="routeToCalender">Calendar View</p>
                              <p class="view-options-p" @click="routeToList" v-bind:class="{'view_option' : IsListView}">List View</p>
                            </div>
                        </div>
                        <span  style="cursor: pointer;" slot="reference" >

                            <img v-if="IsClenderView"  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_calendarview.svg`"/>
                            <img v-else  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Imagesic_listview.svg`"/>
                             <img  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_dropdown.svg`"/>
                          </span>
                    </ob-popover>
                  </div>
              </li>
            </ul>
          </ul>
        </div>
        <time-sheets-filter v-if="showFilter" @cancel="cancelFilter"></time-sheets-filter>
        <div class="col-md-12">
          <timesheets-calender
            @hideLegend="hideLegend"
            @changedDate="changedDate"
            ref="timeSheetsCalender"
            :defaultView="CalendarView"
            :calendarPlugins="calendarPlugins"
          ></timesheets-calender>
        </div>
      </div>
      <div>
        <Manual-Remainder  :show.sync="OpenTimesheetManualRemainder"></Manual-Remainder>
        <generate-report :show.sync="showgeneratePopup"></generate-report>
        <share-timesheets :Year="Year" :Month="Month" :show.sync="showShareTimesheetPopup"></share-timesheets>
        <share-timesheets-mail-popup  :ShareSelectedTimesheet="shareSelectedTimesheet" :ShareReportType="shareReportType" :SelectedMonth="MonthName" :show.sync="showShareTimesheetMailPopup"></share-timesheets-mail-popup>
      </div>
    </div>
  </base-layout>
</template>
<script>
import ShareTimesheets from './Timesheets/ShareTimesheets.vue'
import ShareTimesheetsMailPopup from './Timesheets/ShareTimesheetsMailPopu.vue'
import ManualRemainder from './Timesheets/ManualRemainder.vue'

import customViewPlugin from "./Timesheets/Calender/CustomViews/custom-view-monthly.js";

import AddTimesheets from "./Timesheets/AddTimesheets.vue";
import GenerateReport from "./Timesheets/GenerateReport.vue";
import TimeSheetsCalender from "./Timesheets/Calender/TimeSheetsCalender.vue";
import TimeSheetsFilter from "./Timesheets/TimeSheetsFilter";
export default {
  props: ["TraineeEmployeeId"],
  data() {
    return {
      MonthName:'',
      IsDCAAComplianceToggleOn:false,
      shareSelectedTimesheet:'',
      shareReportType:'',
      showShareTimesheetMailPopup:false,
      showShareTimesheetPopup:false,
       IsReportGenerationInProgress:false,
       IsCalender:true,
      IsListView:false,
       IsClenderView:true,
      selectAddTimesheet:false,
      OpenTimesheetManualRemainder:false,
      isFilterApplied: false,
      generatePopupSuccessContent:false,
      showFilter: false,
      TimesheetApprove: false,
      IsSupervisor: false,
      legend: true,
      isActive: false,
      calendarPlugins: [customViewPlugin],
      TimeSheets: "TimeSheets",
      showgeneratePopup: false,
      CalendarView: "customViewMonthly",
      Month: moment().format("MM"),
      Year: moment().format("YYYY"),
      monthOptions: {
        minimumResultsForSearch: -1,
        dropdownAutoWidth: true,
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
          {
            id: "01",
            text: "January"
          },
          {
            id: "02",
            text: "February"
          },
          {
            id: "03",
            text: "March"
          },
          {
            id: "04",
            text: "April"
          },
          {
            id: "05",
            text: "May"
          },
          {
            id: "06",
            text: "June"
          },
          {
            id: "07",
            text: "July"
          },
          {
            id: "08",
            text: "August"
          },
          {
            id: "09",
            text: "September"
          },
          {
            id: "10",
            text: "October"
          },
          {
            id: "11",
            text: "November"
          },
          {
            id: "12",
            text: "December"
          }
        ]
      },
      timeSheetOptions: {
        minimumResultsForSearch: -1,
        dropdownAutoWidth: true,
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
          {
            id: "TimeSheets",
            text: "Timesheets & Expenses"
          },
          {
            id: "MyTimeSheets",
            text: "My Timesheets & Expenses"
          }
        ]
      },
      options: {
        minimumResultsForSearch: -1,
        dropdownAutoWidth: true,
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
          {
            id: "dayGridMonth",
            text: "Monthly View"
          },
          {
            id: "customViewYearly",
            text: "Yearly View"
          }
        ]
      },
      options1: {
        format: "YYYY",
        dayViewHeaderFormat: "YYYY",
        ignoreReadonly: true,
        minDate: moment("01/01/1970").format("MM/DD/YYYY"),
        widgetPositioning: {
          horizontal: "left",
          vertical: "bottom"
        }
      },
      IsDateChangedFirstTime: false
    };
  },
  components: {
    "Manual-Remainder":ManualRemainder,
    "add-timesheets": AddTimesheets,
    "timesheets-calender": TimeSheetsCalender,
    "generate-report": GenerateReport,
    "time-sheets-filter": TimeSheetsFilter,
     "share-timesheets":ShareTimesheets,
     "share-timesheets-mail-popup":ShareTimesheetsMailPopup
  },
  watch: {
    showgeneratePopup(val) {
      this.hideLegend(val);
    },
    fullDate(val) {
      if (this.$refs.timeSheetsCalender && !this.IsDateChangedFirstTime) {
        this.$refs.timeSheetsCalender.gotoDate(this.fullDate);
      }
    },
    TimeSheets(val) {
      if (val == "TimeSheets") {
        this.$router.push({ name: "employer-timesheets" });
      } else if (val == "MyTimeSheets") {
        this.$router.push({ name: "my-timesheets" });
      }
    }
  },
  computed: {
    ManualRemainderEmpList()
    {
        return this.$store.getters.getManualRemainderEmpIds;
    },
    isSearchFilterAppiled() {
      if (
        (this.$store.getters.getTimeSheetSearchText != null &&
          this.$store.getters.getTimeSheetSearchText != "" &&
          this.$store.getters.getTimeSheetEmployeeIdList.length > 0) ||
        (this.isFilterApplied == true &&
          this.$store.getters.getTimeSheetEmployeeIdList.length > 0)
      ) {
        return true;
      } else {
        return false;
      }
    },
    fullDate() {
      return `${this.Year}-${this.Month}-01`;
    }
  },
  created() {
    this.getSupervisor();
    this.getTimeSheetPreference()
    //  this.fetchMonthlyCalenderEventsDetails()
    if (this.$refs.timeSheetsCalender) {
      this.$refs.timeSheetsCalender.gotoDate(this.fullDate);
    }
  },
  mounted() {

    events.listen('IsTimesheetInProgress', (val) => { 
      this.IsReportGenerationInProgress = val;
    })

    this.$nextTick(function() {
      window.addEventListener("resize", this.setWindowHight);
    });
    this.setWindowHight();
    document.getElementsByClassName("main-content")[0].style.cssText =
      "height:100% !important";
  },
  destroyed() {
    //Clear filter when leaves the page
    this.$store.dispatch("resetTimeSheetFilter");
    this.isFilterApplied = false;
    document
      .getElementsByClassName("main-content")[0]
      .removeAttribute("height");
  },
  updated() {
    this.IsDateChangedFirstTime = false;
  },
  methods: {
    addDcaaReport(){
      this.$router.push({path:`dcaa-reports?Supervisor=true`})

      // this.$router.push({name:"employer-dcaareport"})
    },
     getTimeSheetPreference(){
      this.$loading({'loadingText': 'Loading...'}) 
        ajax.get(`TimeSheets/Settings?orgId=${this.loggedInUserObj.orgId}`, {} , (res) => {
              this.IsDCAAComplianceToggleOn = res.data.TimesheetSettings.DCCACompliance
            })
    },
    onShareTimesheetbuttonClick(selectedTimesheets,reportType)
    {
        this.MonthName = this.monthOptions.data.find(v=>v.id == this.Month).text;
        this.shareReportType = reportType;
        this.shareSelectedTimesheet =  selectedTimesheets;
        this.showShareTimesheetPopup = false;
        this.showShareTimesheetMailPopup = true;
    },
    getReportsForShareTimesheets()
    {
       this.shareAttachements = [];
    },
    onShareTimesheetClick()
    {
      this.showShareTimesheetPopup = true;
    },
    routeToCalender()
    {
      this.IsClenderView = true;
      this.IsCalender = true;
      this.IsListView = false;
      this.$router.push({'path': '/employer-timesheets'})
    },
    routeToList()
    {
      this.IsClenderView = false;
      this.IsListView = true;
      this.IsClender = false;
      this.$router.push({'path': '/timesheets-list', query: { listView: "true" }})
    },
    addTimesheets() {
      this.selectAddTimesheet = true
      this.$loading({ 'loadingText': 'Loading...' })
      var routerPush = this.$router.resolve({name: `employee-addtimesheets`,query: {from:  this.$route.name}})
      setTimeout(() => {
        this.$loading({}).close()
      }, 600)
      window.open(routerPush.href, "_self")
    },
    onPreviousMonthClick() {
      let x = `${this.Year}-${this.Month}-01`;
      let date = moment(x)
        .subtract(1, "months")
        .format("YYYY-MM-DD");
      this.Month = moment(date).format("MM");
      this.Year = moment(date).format("YYYY");
    },
    onNextMonthClick() {
      let x = `${this.Year}-${this.Month}-01`;
      let date = moment(x)
        .add(1, "months")
        .format("YYYY-MM-DD");
      this.Month = moment(date).format("MM");
      this.Year = moment(date).format("YYYY");
    },
    OnTimesheetApprove(val) {
      this.TimesheetApprove = val;
    },
    setWindowHight() {
      if (this.CalendarView == "customViewMonthly") {
        if (
          document.getElementById("CalenderInnerDiv") != null &&
          document.getElementById("CalenderInnerDiv") != undefined
        ) {
          document.getElementById("CalenderInnerDiv").style.minHeight =
            window.innerHeight - 230 + "px";
          document.getElementById("CalenderInnerDiv").style.maxHeight =
            window.innerHeight - 230 + "px";
        }
      }
    },
    getSupervisor() {
      ajax.get(`Supervisor/IsSupervisor?empId=${loggedInUserObj.empId}`, {}, res => {
        if (res.data) {
          this.IsSupervisor = res.data
          return false;
        }
        else{
           this.$router.push({ name: "my-timesheets" });
        }
      });
    },
    hideLegend(val) {
      this.legend = !val;
    },
    changedDate(v, x) {
      this.Year = moment(v).format("YYYY");
      this.Month = moment(v).format("MM");
      this.IsDateChangedFirstTime = x;
    },
    generateReport() {
      this.showgeneratePopup = true;
    },
   toggle() {
       this.isActive = this.isActive ? false : true;
   },
   addDcaa(){
        this.$router.push({name:"dcaa-reports"})
       },
    cancelFilter() {
      this.showFilter = false;
    },
    filter() {
      this.isFilterApplied = true;
    },
    clearFilter() {
      this.$store.dispatch("resetTimeSheetFilter");
      this.isFilterApplied = false;
      let Obj = null;
      events.fire("applyFilter", Obj);
    },
    cancel(){
      this.generatePopup = false
      this.generatePopupSuccessContent = false
      //this.EmpType = 'IndividualEmployee'
    },
    exportToExcel() {
      let y = this.Year;
      let m = this.Month;

      var firstDay = new Date(y, m - 1, 1);
      var lastDay = new Date(y, m, 0);

      var tcycle = this.$store.getters.getTimeSheetFilterValue('TimeSheetCycle');
      if (tcycle == 'Semi-Monthly') {
        tcycle = 'SemiMonthly';
      } else if (tcycle == 'Bi-Weekly') {
        tcycle = 'BiWeekly';
      }

      let requestObj = {
        ProjectId: this.$store.getters.getTimeSheetFilterValue('ProjectTitle'),
        ClientId: this.$store.getters.getTimeSheetFilterValue('ClientName'),
        EndClientOrgName: this.$store.getters.getTimeSheetFilterValue('EndClientName'),
        ReportingAuthorityId: this.$store.getters.getTimeSheetFilterValue('ReportingAuthority'),
        TimesheetStatus: this.$store.getters.getTimeSheetFilterValue('TimeSheetStatus'),
         ExpenseStatus:this.$store.getters.getTimeSheetFilterValue('ExpenseStatus'),
        EmployeeStatus: this.$store.getters.getTimeSheetFilterValue('EmployeeStatus'),
        BillingStatus: this.$store.getters.getTimeSheetFilterValue('BillingStatus'),
        ProjectStatus: this.$store.getters.getTimeSheetFilterValue('ProjectStatus'),
        TimeSheetCycle: this.$store.getters.getTimeSheetFilterValue('TimeSheetCycle'),
         TaxTerms: this.$store.getters.getTimeSheetFilterValue('TaxTerms'),
        EmploymentType: this.$store.getters.getTimeSheetFilterValue('EmploymentType'),

        TimesheetFromDate: moment(firstDay).format("MM/DD/YYYY"),
        TimesheetToDate: moment(lastDay).format('MM/DD/YYYY'),

        SearchText: this.searchText,

        TimesheetsSortType: 'EmployeeName',
        IsAscending: true,
        IsExportExcel: true,
        IsSupervisor: true,
       // ConnectionId : $.connection.notificationHub.connection.id
      }
      this.$loading({ loadingText: "Loading..." });
      ajax.put(`TimeSheets/Export/Excel?orgId=${this.loggedInUserObj.orgId}`, requestObj, res => {
        if (res.data.State == true) {
          this.generatePopupSuccessContent =true
          // this.cancel();
         // window.open(res.data.ReportUrl, "_blank");

          // events.fire("IsTimesheetInProgress",true);
          // let report = 'Timesheet Excel';
          // this.$refs.baselayout.$refs.draggablTimesheetReportProgress.reportType = report;
          // this.$refs.baselayout.$refs.draggablTimesheetReportProgress.showTimesheetDraggablePopUp = true;

          this.$loading({}).close();
        } else if (res.data.State == false) {
          this.$loading({}).close();
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.legend-li
    {
      padding-right: 0px;
    }
   .popper{
        background: #1f2023;
        color: #ffffff;
        border: none;

        top: 6px !important;
        //left: -14px !important;

        -webkit-box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
        -moz-box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
        box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);

       .view-options{
          margin:-15px;
          display: block;
          color: #ffff;
          font-weight: 600;
          font-size: 13px;
          padding: 1px 0 5px 0px;

          .view-options-p
          {
            padding: 8px 15px;
            cursor:pointer;
            color:#f9eded;
          }
          .view-options-p:hover{
                 color: #fff !important;
                 background: #423e3e !important;
          }
        }

    }
  .view_option{
    color: #fff !important;
    background: #423e3e !important;
  }
 .send_manual_remainder{
    //  background-color: #edf4fc;
      cursor: pointer;
      padding: 6px;
      border-radius: 5px;
      color: #254c86;
      font-size: 14px;
      font-weight: 600;
  }
   .send_manual_remainder:hover{
      background-color: #edf4fc;
      // cursor: pointer;
      // padding: 6px;
      // border-radius: 5px;
      // color: #254c86;
      // font-size: 14px;
      // font-weight: 600;
  }
.timesheet_layout {
  height: 100%;
  overflow: auto;
  margin-right: -14px;
}
.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #000000;
  background-color: #000000;
}
.circle1 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #2027e8;
  background-color: #2027e8;
}
.circle2 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #13da7c;
  background-color: #13da7c;
}
.circle3 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #f8d21c;
  background-color: #f8d21c;
}
.circle4 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #ef4457;
  background-color: #ef4457;
}
.circle5 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #F96301;
  background-color: #F96301;
}
.span_styles {
  color: #000000;
  font-weight: 600;
  font-size: 12px;
}
.h3_styles {
  color: #000000;
  font-weight: 600;
}
.timesheet_filter {
  cursor: pointer;
}
.arrow_icon {
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  padding: 2px 6px 5px 6px;
}
.arrow_icon:hover {
  cursor: pointer;
}
.circle6{
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color:#aa99d6;
  background-color:#aa99d6;
}
.circle7 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #A31D95;
  background-color: #A31D95;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmployerTimesheets.vue